/**
 * Features still kept out of production. Read at call time so tests can
 * stub the environment.
 */

/** Robotín, the chat assistant: hidden while under development. */
export const isChatEnabled = (): boolean => false;
